module.exports = __webpack_public_path__ + "img/close-white.fa920c67.svg";